import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, CheckCircle2, Phone } from 'lucide-react';
import styles from './AboutHero.module.css';

const HERO_BANNER = encodeURI('/images/banner1 (2).jpeg');

const POINTS = [
  'Manufacturer & supplier since 2018',
  'Food, beverage & industrial grades',
  'Pan-India logistics support',
];

const AboutHero = () => (
    <section className={styles.hero} aria-labelledby="about-hero-title">
      <div className={styles.wrap}>
        <motion.div
          className={styles.copy}
          initial={{ opacity: 0, x: -24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className={styles.eyebrow}>
            <span className={styles.eyebrowLine} aria-hidden="true" />
            <span>About Greeneri Paper Tradelinks</span>
          </div>

          <h1 id="about-hero-title" className={styles.title}>
            Paper packaging
            <span className={styles.titleAccent}> built on trust</span>
          </h1>

          <p className={styles.lead}>
            Established in 2018 in Meerut — we manufacture and supply premium
            paper-based packaging products and raw materials with consistent quality,
            scalable production, and dependable delivery for brands across India.
          </p>

          <ul className={styles.points}>
            {POINTS.map((text) => (
              <li key={text}>
                <CheckCircle2 size={20} strokeWidth={2.5} />
                {text}
              </li>
            ))}
          </ul>

          <div className={styles.ctas}>
            <Link to="/products" className={styles.btnFill}>
              View products
              <ArrowUpRight size={15} />
            </Link>
            <Link to="/contact" className={styles.btnLine}>
              <Phone size={15} />
              Contact us
            </Link>
          </div>
        </motion.div>

        <motion.div
          className={styles.visual}
          initial={{ opacity: 0, x: 28 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className={styles.visualFrame}>
            <motion.div
              className={styles.imgMain}
              animate={{ scale: [1, 1.02, 1] }}
              transition={{ duration: 14, repeat: Infinity, ease: 'easeInOut' }}
            >
              <img src={HERO_BANNER} alt="Greeneri manufacturing and quality operations" />
              <div className={styles.imgOverlay} />
            </motion.div>

            <motion.div
              className={styles.chipTrust}
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
            >
              <span className={styles.chipNum}>Food-grade</span>
              <span className={styles.chipLbl}>Certified materials</span>
            </motion.div>

            <div className={styles.chipQuality}>
              <span>ISO-grade</span>
              quality focus
            </div>

            <div className={styles.cornerAccent} aria-hidden="true" />
          </div>
        </motion.div>
      </div>

      <div className={styles.strip} aria-hidden="true">
        <div className={styles.stripTrack}>
          {[
            'PE Coated Rolls',
            'Food Wrap',
            'Cup Sleeves',
            'Packaging',
            'Notebook Covers',
            'Sugar Sachets',
            'PE Coated Rolls',
            'Food Wrap',
            'Cup Sleeves',
            'Packaging',
          ].map((t, i) => (
            <span key={`${t}-${i}`}>{t}</span>
          ))}
        </div>
      </div>
    </section>
);

export default AboutHero;
